import { render } from "./BaseCard.vue?vue&type=template&id=b2675e14&scoped=true&ts=true"
import script from "./BaseCard.vue?vue&type=script&lang=ts"
export * from "./BaseCard.vue?vue&type=script&lang=ts"

import "./BaseCard.vue?vue&type=style&index=0&id=b2675e14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2675e14"]])

export default __exports__